import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Select,
  Button,
 
  Tag,
  Space,
  Typography,
  Row,
  Col,
  Divider,
  App,
  Card,
  Modal,
  Spin,
} from "antd";

import {
  MailOutlined,
  LinkedinOutlined,
  PlusOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,
  SendOutlined,
  ClearOutlined,
  LoadingOutlined,
  CloseOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
import countrycode from "../../utility/countrycode.json";
import Hexapi from "../../utility/HexAPI/Hexapi";
import FormField from "../../component/fields/Inputbox";
import { showConfirm } from "../../utility/showconfirm";
import ResumeUploadParser from "./ResumeUploadParser";
import "./customer.css"
import Urlencoder from "../../utility/Urluncoder";
import { Aesdecryption } from "../../utility/Aes/Aes";
import banner from "../../assets/hexaccounts.png"
import { useNavigate } from "react-router-dom";
const { Title, Text } = Typography;
const { Option } = Select;
const INITIAL_FORM = {
  fullname: "",
  currentaddress: "",
  email: "",
  countrycodecontact: "+91",
  contactnumber: "",
  appliedposition: "",
  source: undefined,
  referredby: "",
  StageID: 2,
};


export default function Accountsexecutive({
  open,
  onClose,
  refreshtableadd,
}) {

  const [form] = Form.useForm();

  const isModal = typeof open === "boolean";
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 576);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 576);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [agentID,setagentID]=useState(null)
  const [resumeFile, setResumeFile] = useState(null);
  const [isresume, setisresume] = useState(false);
  const [resumerequired,setresumerequired]=useState(true)
  const [formData, setFormData] = useState({
    stage: [],
    source: [],
    appliedpositionfor: [],
    aiconfig:[]
  });
  const [resumeUploading, setResumeUploading] = useState(false);
  const [formDataLoading, setFormDataLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [resumeSummary,setresumeSummary]=useState("")
  const [resumedataai,setresumedataai]=useState(null)
  const [disabledFields, setDisabledFields] = useState({
    source: false,
    appliedposition: false,
  })
    

const navigate = useNavigate();
const Urlencoder = async (url) => {
  const lastPart = url.split("?")[1];

  if (isValidBase64(lastPart)) {
    return atob(lastPart);
  }

  return url; // normal URL/query ke liye
};

 const isValidBase64 = (str) => {
  try {
    if (!str || typeof str !== "string") return false;
    atob(str);
    return true;
  } catch {
    return false;
  }
};

const safeBtoa = (str) => {
  return btoa(unescape(encodeURIComponent(str)));
};

const decodeUrl = async (url) => {
  try {
    if (!url) return null;

    const [baseUrl, queryString] = url.split("?");

    let finalUrl = url;

    if (queryString) {
      let decrypted = null;

      try {
        decrypted = Aesdecryption(queryString);
      } catch (e) {
        console.warn("Aesdecryption failed, using normal query:", e);
      }

      if (decrypted) {
        finalUrl = `${baseUrl}/?${safeBtoa(decrypted)}`;
      } else {
        
        finalUrl = url;
      }
    }

    const decodedData = await Urlencoder(finalUrl);
    return decodedData;
  } catch (err) {
    console.error("decodeUrl error:", err);
    return null;
  }
};
const safeAtob = (str) => {
  try {
    return atob(str);
  } catch {
    return null;
  }
};

const getQueryObject = (result) => {
  let query = result;

  // agar full URL hai
  if (result.includes("?")) {
    query = result.split("?")[1];
  }

  const params = new URLSearchParams(query);

  // fbclid remove
  params.delete("fbclid");

  let encodedKey = null;

  for (const [key, value] of params.entries()) {
    if (value === "") {
      encodedKey = key;
      break;
    }
  }

  // agar URL aisa hai: ?YWdlbnRJRD0x...
  if (encodedKey) {
    const decoded = safeAtob(encodedKey);

    if (decoded) {
      return Object.fromEntries(new URLSearchParams(decoded));
    }
  }

  return Object.fromEntries(params);
};
useEffect(() => {
  const loadData = async () => {
    const result = await decodeUrl(window.location.href);

    console.log(result, "decoded url response");

    const res = getQueryObject(result);

    console.log(res, "resss");
    if (res?.agentID) {
      setagentID(res.agentID);
    }

    if(res?.sourceid){
      form.setFieldValue("source", Number(res.sourceid))
      setDisabledFields((prev) => ({ ...prev, source: true }));
    }else{
        setDisabledFields((prev) => ({ ...prev, source: false }));
    }

    if(res?.appliedposition){
      form.setFieldValue("appliedposition", Number(res.appliedposition))
      setDisabledFields((prev) => ({ ...prev, appliedposition: true }));
    }else{
        setDisabledFields((prev) => ({ ...prev, appliedposition: false }));
    }
  };

  loadData();
}, []);
  useEffect(() => {
    if (resumeFile) setisresume(false);
  }, [resumeFile]);


  const getformData = async () => {
    try {
      setFormDataLoading(true);

      const obj = {
        query: `[dbo].[HCMS_Proc_Candidate_Add_getFormData] @AgentID='{0}'`,
        queryArr: [`${agentID}`],
      };

      const resp = await Hexapi(obj);
console.log(resp,"resp")
      if (resp) {
        setFormData({
          source: resp.source || [],
          appliedpositionfor: resp?.appliedpositionfor || [],
          aiconfig:resp.aiconfig
        });
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      setFormDataLoading(false);
    }
  };
  const Logsubmit=async(InputTokens,OutputTokens,totaltime,Answer,MODEL_ID)=>{
  const stats=`in-${InputTokens}out-${OutputTokens}-Totalthinkingtime-${totaltime}`
try {
  const obj={
    query:`[dbo].[HCMS_Proc_OCR_Log_Submit]
    @AgentID='{0}',
    @ModalName='{1}',
    @InputTokens='{2}',
    @OutputTokens='{3}',
    @Stats='{4}',
    @Answer='{5}',
    @targetedFor='{6}',
     @Imagetokens='{7}'
    `,
    queryArr:[`${agentID}`,`${MODEL_ID}`,`${InputTokens}`,`${OutputTokens}`,`${stats}`,`${Answer}`,"Resume Summarization",0]
  }
  
  const resp = await Hexapi(obj)
} catch (error) {
  console.log("Logging failed", error);
}
}
const handleSummarize = async (appliedID) => {
  const selectedPosition = formData?.appliedpositionfor?.find(
    (x) => String(x.recid || x.RecID) === String(appliedID)
  );

  console.log(selectedPosition, "selectedPosition");
  console.log(resumedataai, "resumedataai");

  const systemprompt = selectedPosition?.prompt || selectedPosition?.Prompt || "";

  const userprompt = `
Applied Position:
${selectedPosition?.label || selectedPosition?.AppliedPositionFor || ""}

Candidate Resume Data:
${JSON.stringify(resumedataai, null, 2)}
`;

  if (!formData?.aiconfig || formData.aiconfig.length === 0) return;

  const aiconfigdata = formData?.aiconfig?.[1];

  const startTime = Date.now();

  try {
    const geminiUrl = aiconfigdata?.baseurl

    const response = await fetch(`${geminiUrl}?key=${aiconfigdata?.apikey}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        contents: [
          {
            role: "user",
            parts: [{ text: userprompt }],
          },
        ],
        systemInstruction: {
          parts: [{ text: systemprompt }],
        },
        generationConfig: {
          maxOutputTokens: Math.floor(Number(aiconfigdata?.maxtokens)) || 2048,
          temperature: 0.4,
        },
      }),
    });
    
    if (!response.ok) {
      let errorMsg = `Error ${response.status}`;

      try {
        const errData = await response.json();
        errorMsg = errData?.error?.message || errorMsg;
      } catch {}

      console.log(errorMsg, "Gemini error");
      return "";
    }

    const parsed = await response.json();

    const finalText =
      parsed?.candidates?.[0]?.content?.parts
        ?.map((p) => p.text || "")
        .join("") || "";

    const inputTokens = parsed?.usageMetadata?.promptTokenCount || 0;
    const outputTokens = parsed?.usageMetadata?.candidatesTokenCount || 0;

    const totalSeconds = ((Date.now() - startTime) / 1000).toFixed(2);

    console.log(finalText, "finalText");
    console.log({
      inputTokens,
      outputTokens,
      totalTokens: inputTokens + outputTokens,
      totalSeconds,
    });

    setresumeSummary(finalText);
await Logsubmit(inputTokens,outputTokens,totalSeconds,finalText,aiconfigdata?.modelname)
    return finalText;
  } catch (err) {
    console.log(err, "handleSummarize error");
    return "";
  }
};
  useEffect(() => {
    if (agentID) getformData();
  }, [agentID]);

  const getresumeid = async (file) => {
    if (!file) return null;

    const extension = "." + /[^.]+$/g.exec(file.name)[0];

    const obj = {
      query: `[dbo].[HCMS_Proc_Add_Attachment]@AgentID='{0}',@Extension='{1}',@FileName='{2}',@Attachment=$%$File$%$`,
      queryArr: [`${agentID}`, `${extension}`, `${file.name}`],
      file,
    };

    const resp = await Hexapi(obj);
    return resp?.[""]?.[0]?.attachmentid || null;
  };

  const getdesignation = async (desing) => {
    try {
      if (!desing) return null;

      if (!isNaN(desing) && String(desing).trim() !== "") {
        return Number(desing);
      }

      const value = String(desing).trim();

      const matched = formData?.appliedpositionfor?.find(
        (x) =>
          String(x.AppliedPositionFor || x.appliedpositionfor || x.label || "")
            .trim()
            .toLowerCase() == value.toLowerCase()
      );
      if (matched) return matched.recid || matched.recid || matched.value;
      const obj = {
        query: `[dbo].[HCMS_Proc_Add_Designation] @AppliedPositionFor='{0}'`,
        queryArr: [value],
      };

      const resp = await Hexapi(obj);
      const data = resp?.[""]?.[0];

      if (data?.command === 1) return data?.RecID || data?.recid;

      return null;
    } catch (error) {
      console.log(error);
      return null;
    }
  };



  const handleSubmit = async () => {
    try {
     const sourceLower = selectedSourceLabel?.trim()?.toLowerCase();

const allStepFields = {
  1: ["fullname", "email", "contactnumber"],
  3: [
    "appliedposition",
    "source",
    "StageID",
    ...(sourceLower === "referral" ? ["referredby"] : []),
    ...(sourceLower === "other" ? ["subsource"] : []),
  ],
};

      const stepErrors = [];

      if (!resumeFile) {
        setisresume(true);

        stepErrors.push({
          stepIndex: 0,
          stepTitle: "Resume Upload",
          errors: ["Please upload resume / CV"],
        });
      }

      for (const [stepIndex, fields] of Object.entries(allStepFields)) {
        try {
          await form.validateFields(fields);
        } catch (errorInfo) {
          const errors = errorInfo.errorFields
            ?.map((f) => f.errors?.[0])
            .filter(Boolean);

          if (errors?.length > 0) {
            stepErrors.push({
              stepIndex: Number(stepIndex),
             
              errors,
            });
          }
        }
      }

      if (stepErrors.length > 0) {
        Modal.error({
          title: "Please fix the following errors before submitting",
          centered: true,
          content: (
            <div>
              {stepErrors.map(({ stepTitle, errors }) => (
                <div key={stepTitle} style={{ marginBottom: 12 }}>
                  <Text strong style={{ color: "#ff4d4f" }}>
                    📌 {stepTitle}
                  </Text>

                  <ul style={{ marginTop: 5, paddingLeft: 20 }}>
                    {errors.map((err, i) => (
                      <li key={i}>{err}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          ),
          
        });

        return;
      }

      setSubmitLoading(true);
      const values = form.getFieldsValue(true);
      const resumeid = await getresumeid(resumeFile);
      const resumesummary = await handleSummarize(values.appliedposition)
      const obj = {
        query: `[dbo].[HCMS_Proc_Add_Candidate]
    @AgentID='{0}', @FullName='{1}', @DOB='{2}', @Gender='{3}', @Nationality='{4}',
    @CurrentAddress='{5}', @Email='{6}', @CountryCode='{7}', @ContactNumber='{8}',
    @AlternateNumber='{9}', @LinkedIn='{10}', @CurrentDesignation='{11}',
    @CurrentCompany='{12}', @TotalExperience='{13}', @NoticePeriod='{14}',
    @CurrentCTC='{15}', @ExpectedCTC='{16}', @Qualification='{17}', @Stream='{18}',
    @Institute='{19}', @PassingYear='{20}', @AppliedPosition='{21}',
    @subsource='{22}', @Source='{23}', @ReferredBy='{24}',
     @Remarks='{25}', @Skills='{26}', @ResumeID='{27}',@ResumeSummary='{28}'`,
        queryArr: [
          `${agentID}`,
          `${values.fullname || ""}`,
          `${""}`,
          `${""}`,
          `${"Indian"}`,
          `${values.currentaddress || ""}`,
          `${values.email || ""}`,
          `${values.countrycodecontact || "+91"}`,
          `${values.contactnumber || ""}`,
          `${""}`,
          `${""}`,
          `${""}`,
          `${""}`,
          `${""}`,
          `${""}`,
          `${0}`,
          `${0}`,
          `${""}`,
          `${""}`,
          `${""}`,
          `${""}`,
          `${values.appliedposition || ""}`,
          `${""}`,
          `${values.source || ""}`,
          `${""}`,
          `${""}`,
          `${""}`,
          `${resumeid || ""}`,
          `${resumeSummary}`
          ,
        ],
      };

      const result = await Hexapi(obj)

      if (result?.[""]?.[0]) {
        if (result[""][0].command == 0){
showConfirm({
          content: result[""][0]?.msg,
          okText: "OK",
        });
        }
        

        if (result[""][0].command == 0) return;
        form.resetFields();
        setResumeFile(null);
        setisresume(false);
        navigate("/thank-you-page", { replace: true });
        if (isModal) onClose?.();
       
        
      }
    } catch (err) {
      console.log(err, "submit error");
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleReset = () => {
    Modal.confirm({
      title: "Reset form?",
      content: "All entered data will be cleared.",
      okText: "Yes, Reset",
      cancelText: "Cancel",
      centered: true,
      onOk: () => {
        form.resetFields();
        
        setResumeFile(null);
        setisresume(false);
       
      },
    });
  };

  const handleClose = () => {
    form.resetFields();
    setResumeFile(null);
    setisresume(false);
    onClose?.();
  };

  const PhoneAddon = (fieldName) => (
    <Form.Item name={fieldName} noStyle initialValue="+91">
      <Select
        style={{ width: isMobile ? 85 : 110 }}
        showSearch
        optionFilterProp="children"
      >
        {countrycode.map((c) => (
          <Option key={c.dial_code} value={c.dial_code}>
            {c.dial_code}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );

  const selectedSource = Form.useWatch("source", form);

  const selectedSourceLabel = formData.source
    ?.find((x) => x.recid == selectedSource)
    ?.label?.toLowerCase();

 const FormContent = (
  <div className="candidate-form-layout" style={{overflow:"auto"}}>
   
    <Card
      className="candidate-header-card"
      style={{
        flexShrink: 0,
        borderRadius: isModal ? 0 : 12,
        borderLeft: isModal ? "none" : undefined,
        borderRight: isModal ? "none" : undefined,
        borderTop: isModal ? "none" : undefined,
        marginBottom:'10px'
      }}
    >
      <Row
        justify="space-between"
        align="middle"
        // gutter={[8, 8]}
        className="candidate-header-row"
      >
        <Col xs={24} sm={24} style={{margin:"0px"}}>
  <img src={banner} className="img-fluid" style={{ width:"100%"}}/>
</Col>
        <Col xs={24} sm={24} style={{marginTop:"10px"}}>
          <div className="candidate-title-box">
            <Title level={isMobile ? 5 : 4} className="candidate-main-title" style={{textAlign:"center"}}>
              Apply For Job
            </Title>

            <p className="candidate-sub-title" style={{textAlign:"center"}}>
              At Hex Business Innovation
            </p>
          </div>
        </Col>


       
      </Row>
    </Card>

    <div className="candidate-scroll-body2">
      <Spin
        spinning={formDataLoading}
        tip="Loading form data..."
        indicator={<LoadingOutlined style={{ fontSize: 32 }} spin />}
      >
        <Card className="candidate-form-card">
           <Row gutter={[24, 0]}>
   
           </Row>
       
          <Form
            preserve={true}
            form={form}
            layout="vertical"
            initialValues={INITIAL_FORM}
            requiredMark="optional"
          >
            <div >
            
              <Row gutter={[16, 0]}>
                <Col xs={24} sm={16} md={6}>
                  <ResumeUploadParser
                    setresumedataai={setresumedataai}
                    setresumerequired={setresumerequired}
                    formData={formData}
                    form={form}
                    agentID={agentID}
                    resumeFile={resumeFile}
                    setResumeFile={setResumeFile}
                    isresume={isresume}
                    setResumeUploading={setResumeUploading}
                  />
                </Col>
              </Row>
            </div>
{!resumeFile && (
  <div style={{
    display: "flex",
    alignItems: "center",
    gap: 6,
    marginBottom: 12,
    padding: "6px 12px",
    background: "#fff7e6",
    border: "1px solid #ffd591",
    borderRadius: 6,
    width: "fit-content"
  }}>
    <span style={{ fontSize: 14 }}>⚠️</span>
    <Text style={{ fontSize: 13, color: "#d46b08" }}>
      Please upload your Resume / CV to enable the form fields
    </Text>
  </div>
)}
            <div >

              <Row gutter={[16, 0]}>
                <Col xs={24} sm={12} md={12}>
                  <FormField disabled={resumerequired} name="fullname" label="Full Name" required placeholder="Enter full name" />
                </Col>             

                <Col xs={24} sm={12} md={12}>
                  <FormField
                    name="email"
                    label="Email ID"
                    type="email"
                    required
                    disabled={resumerequired}
                    prefix={<MailOutlined />}
                    placeholder="name@example.com"
                  />
                </Col>

                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    label={
                      <>
                        Contact Number{" "}
                        <span style={{ color: "#ff0000b0", marginLeft: 3 }}>*</span>
                      </>
                    }
                    name="contactnumber"
                    required
                    disabled={resumerequired}
                    rules={[
                      { required: true, message: "Contact number is required" },
                      { len: 10, message: "Must be exactly 10 digits" },
                      { pattern: /^[0-9]+$/, message: "Numbers only" },
                    ]}
                  >
                    <Input
                      addonBefore={PhoneAddon("countrycodecontact")}
                      placeholder="10-digit number"
                      maxLength={10}
                      disabled={resumerequired}
                      size="large"
                    />
                  </Form.Item>
                </Col>
<Col xs={24} sm={12} md={12}>
                  <FormField
                    required
                    disabled={disabledFields.appliedposition || resumerequired}
                    type="select"
                    
                    name="appliedposition"
                    label="Applied for Position"
                    options={formData.appliedpositionfor.map((s) => ({
                      value: s.recid,
                      label: s.label,
                    }))}
                  />
                </Col>
               {/* <Col xs={24} sm={12} md={12}>
                  <FormField
                  disabled={disabledFields.source || resumerequired}
                    required
                    name="source"
                    label="How did you find out about us?"
                    type="select"
                    options={formData.source.map((s) => ({
                      value: s.recid,
                      label: s.label,
                    }))}
                  />
                </Col> */}
                <Col xs={24} sm={12} md={12}>
                  <FormField
                    disabled={resumerequired}
                    name="currentaddress"
                    label="Current Address"
                    placeholder="Street, City, State, PIN"
                  />
                </Col>
              </Row>
               <Col xs={24} sm={24}>
          <Space wrap className="candidate-header-actions" style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
            <Button
              className="candidate-submit-btn"
              style={{ background: "#AD0000", color: "white" }}
              icon={submitLoading ? <LoadingOutlined /> : <SendOutlined />}
              onClick={handleSubmit}
              loading={submitLoading}
              disabled={formDataLoading}
            >
              Submit
            </Button>

            {isModal && (
              <Button
                type="text"
                icon={<CloseOutlined />}
                onClick={handleClose}
                className="candidate-close-btn"
              />
            )}
          </Space>
        </Col>
            </div>
          </Form>
        </Card>
      </Spin>
    </div>
  </div>
);

  return (
    <App>
      
        <div
          style={{
            width: "100%",
            height: isMobile ? "100dvh" : "100vh",
            padding: isMobile ? "10px" : "0px",
            overflow: "auto",
          }}
        >
          <div
            style={{
              margin: "0 auto",
              height: "100%",
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
              // overflow: "hidden",
            }}
          >
            {FormContent}
          </div>
        </div>
      
    </App>
  );
}